import { createElementBlock as o, openBlock as r, mergeProps as n, createStaticVNode as l } from "vue";
import { _ as C } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const d = {};
function i(t, e) {
  return r(), o("svg", n(t.$attrs, {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    l('<g id="Info Circle Outline"><g id="Icon"><path d="M14.8461 11.1353C14.8461 10.498 15.3627 9.98145 16 9.98145C16.6372 9.98145 17.1538 10.498 17.1538 11.1353C17.1538 11.7725 16.6372 12.2891 16 12.2891C15.3627 12.2891 14.8461 11.7725 14.8461 11.1353Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17 14.9814L17 20.9814C17 21.5337 16.5523 21.9814 16 21.9814C15.4477 21.9814 15 21.5337 15 20.9814L15 14.9814C15 14.4292 15.4477 13.9814 16 13.9814C16.5523 13.9814 17 14.4292 17 14.9814Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16 4.98145C9.92487 4.98145 5 9.90631 5 15.9814C5 22.0566 9.92487 26.9814 16 26.9814C22.0751 26.9814 27 22.0566 27 15.9814C27 9.90631 22.0751 4.98145 16 4.98145ZM3 15.9814C3 8.80174 8.8203 2.98145 16 2.98145C23.1797 2.98145 29 8.80174 29 15.9814C29 23.1611 23.1797 28.9814 16 28.9814C8.8203 28.9814 3 23.1611 3 15.9814Z"></path></g></g>', 1)
  ]), 16);
}
const a = /* @__PURE__ */ C(d, [["render", i]]);
export {
  a as default
};
